export interface IChangeBannersOrder {
    order: {
        [id: string]: string,
    };
}
